import { useCallback } from 'react'

import { useMutation, useQueryClient } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'

export function useDeleteRestrictedWord() {
  const queryClient = useQueryClient()

  const deleteMutation = useMutation(
    (id: number) => restrictedWordsService.deleteRestrictedWord(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['restrictedWords'])
      },
    },
  )

  const deleteRestrictedWord = useCallback(
    (id: number) => {
      return deleteMutation.mutateAsync(id)
    },
    [deleteMutation],
  )

  return {
    deleteRestrictedWord,
    isDeleteRestrictedWordLoading: deleteMutation.isLoading,
  }
}
